// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"365":"19a6e38b","501":"de651587"}[chunkId] + ".chunk.js";
};